var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-input',_vm._g(_vm._b({attrs:{"height":_vm.height,"type":"tel","autocomplete":"tel"},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}},'common-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }